var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelSyncReply(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.007,
    height: 22.455,
    viewBox: "0 0 24.007 22.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147612",
    "data-name": "Rectangle 147612",
    width: 24.007,
    height: 22.455,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160165",
    "data-name": "Group 160165",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160164",
    "data-name": "Group 160164",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 5.564,
    cy: 5.564,
    r: 5.564,
    transform: "translate(12.13 10.577)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37794",
    "data-name": "Path 37794",
    d: "M19.487,4.342l0,0h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37795",
    "data-name": "Path 37795",
    d: "M11.273,19.532a8.636,8.636,0,0,1-1.443-.053,8.3,8.3,0,0,1-1.062-.193,8.524,8.524,0,0,1-4.386-2.642,8.578,8.578,0,0,1-2.218-5.779,7.858,7.858,0,0,1,.063-1.04A8.424,8.424,0,0,1,2.494,8.48a8.692,8.692,0,0,1,7.979-6.316A8.556,8.556,0,0,1,17.76,5.659c.024.033.046.068.072.108l-.109.1-1.012.871a1.294,1.294,0,0,0-.121.113,1.047,1.047,0,0,0-.267.977,1.069,1.069,0,0,0,1.055.845h3.8a1.081,1.081,0,0,0,1.081-1.079V4.385a1.368,1.368,0,0,0-.028-.3,1.076,1.076,0,0,0-1.292-.805,1.054,1.054,0,0,0-.461.231l-.634.53-.355.3,0,0h0v0c-.033-.04-.06-.072-.084-.1A10.749,10.749,0,0,0,9.166.133,10.84,10.84,0,0,0,.617,7.253,10.708,10.708,0,0,0,.1,9.437,10.992,10.992,0,0,0,0,10.653a10.737,10.737,0,0,0,.072,1.434,10.27,10.27,0,0,0,.191,1.14,10.648,10.648,0,0,0,1.629,3.738A10.732,10.732,0,0,0,7.947,21.3a10.369,10.369,0,0,0,1.7.333,9.273,9.273,0,0,0,1.027.069c.28,0,.559,0,.839-.019q.564-.036,1.123-.127c.064-.011.126-.029.19-.041a7.284,7.284,0,0,1-1.548-1.984",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37796",
    "data-name": "Path 37796",
    d: "M14.318,9.713l-3.81-2.286L9.266,6.682a1.125,1.125,0,0,0-.6-.164,1.079,1.079,0,0,0-1.006.761,1.227,1.227,0,0,0-.05.376v3.191l0,0v3.229a1.115,1.115,0,0,0,.079.435,1.081,1.081,0,0,0,1.2.663A1.4,1.4,0,0,0,9.307,15l1.4-.843a7.278,7.278,0,0,1,3.606-4.443",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_223",
    "data-name": "Line 223",
    x2: 4.143,
    y2: 4.143,
    transform: "translate(15.622 14.068)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_224",
    "data-name": "Line 224",
    y1: 4.143,
    x2: 4.143,
    transform: "translate(15.622 14.068)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSyncReply);
export default __webpack_public_path__ + "static/media/Cancel-Sync-Reply.932224448dc11f438013915b980b1d52.svg";
export { ForwardRef as ReactComponent };